import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const UsersIcon = ({ color = '#B5BCBD', size = 16, ...props }) => (
  <svg
    viewBox="0 0 24 19"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.019 9.087c1.905 0 3.663.8 4.948 2.252 1.292 1.46 2.023 3.501 2.071 5.77-.772.425-3.68 1.891-7.019 1.891C3.953 19 .834 17.524 0 17.1c.05-2.266.78-4.304 2.071-5.761C3.356 9.887 5.114 9.087 7.02 9.087zm9.087-1.652c1.905 0 3.663.8 4.948 2.251 1.292 1.46 2.023 3.502 2.071 5.771-.771.426-3.673 1.89-7.019 1.89a10.855 10.855 0 0 1-1.24-.074c-.015-2.537-.824-4.837-2.28-6.482a7.71 7.71 0 0 0-1.34-1.201c1.277-1.393 2.986-2.155 4.86-2.155zM7.019 1.652a3.304 3.304 0 1 1 0 6.609 3.304 3.304 0 0 1 0-6.609zM16.106 0a3.304 3.304 0 1 1 0 6.609 3.304 3.304 0 0 1 0-6.609z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

UsersIcon.propTypes = propTypes;

export default UsersIcon;
